import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreWorkflowPermissionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { usePermissionsContext } from '../../../../PermissionsContext'
import { WorkflowPermissionRecord } from '../../../../types'

export function useRestore(): RestoreRowActionOptions<WorkflowPermissionRecord> {
  const { refetch } = usePermissionsContext()
  const [restorePermission] = useRestoreWorkflowPermissionMutation(
    DefaultMutationHookOptions
  )

  return {
    permission: 'admin',
    default: 'active',
    onRestore: async ({ id }) => {
      await restorePermission({ variables: { input: { id } } })
      await refetch()
      simpleRestoreNotification('Permission')
    },
    metadata: ({ deleted, deletedBy, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedBy?.displayName ?? deletedBy?.mail,
      removedDate: deletedDate,
    }),
  }
}
